import genererContact from '@/services/import/contact/genererContact';
import genererTypeContact from '@/services/parametrage/typeContact/genererTypeContact';
import {
  TIERS_TYPE_CLIENT, TIERS_SOUS_TYPE_AUCUN,
} from '@/configuration/tiers/tiersConf';
import store from '@/store/store';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { getAll as getAllTiers } from '@/api/tiers/index';
import { createAll } from '@/api/contacts/index';
import { columns } from '@/services/import/contact/templateContact';
import i18n from '@/i18n/index';
import completeParametrageGeneriqueNonExistant from '@/services/import/General/parametrage/completeParametrageGeneriqueNonExistant';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { isAdresseNullOrComplete, extraireLibelles } from '@/services/import/General/general';
import { REGEX_EMAIL, REGEX_WEBSITE } from '@/configuration/regexConf';
import booleanConverter from '@/services/import/General/booleanConverter';

export function ErrorContactTranslate(errors) {
  if (!errors || !Array.isArray(errors)) return [];
  return errors.map(error => {
    if (error.endsWith('_IS_REQUIRED')) {
      return i18n.t('importationContact.errors.requiredPropertie', { label: error.split('_')[0] });
    }
    if (error.includes('_MAX_LENGTH_')) {
      return i18n.t('importationContact.errors.maxLengthPropertie', { label: error.split('_')[0], length: error.split('_')[error.split('_').length - 1] });
    }
    if (error.includes('_CLIENT_NOT_FOUND')) {
      return i18n.t('importationContact.errors.clientNotFound', { name: error.split('_')[0] });
    }
    switch (error) {
      case 'ADRESSE_IMCOMPLETE':
        return i18n.t('importationContact.errors.adresseIncomplete');
      case 'CONTACT_TYPE_MUST_BE_ENCLOSED_IN_QUOTES_AND_SEPARATED_BY_COMMAS':
        return i18n.t('importationContact.errors.contactTypeMustBeEnclusedInQuotesAndSeparatedByCommas');
      case 'FORMAT_EMAIL_INCORRECT':
        return i18n.t('general.emailFormatError');
      case 'FORMAT_SITE_WEB_INCORRECT':
        return i18n.t('importationContact.errors.formatSiteWebIncorrect');
      default:
        return 'Un problème est survenu';
    }
  }).join(' - ');
}

function validationLigne(ligne, tiers) {
  const error = {
    numLigne: ligne.numLigne,
    errors: [],
  };
  const tier = tiers.find(t => t.referenceExterne === ligne.tiersId);
  if (ligne.tiersId && !tier) error.errors.push(`${ligne.tiersId}_CLIENT_NOT_FOUND`);
  columns.forEach(column => {
    const columnErrors = column.checkValue(ligne[column.key]);
    if (columnErrors.length > 0) error.errors = error.errors.concat(columnErrors);
  });
  if (!isAdresseNullOrComplete(ligne, 'adresse') && booleanConverter(ligne.adresseContactDifferente)) error.errors.push('ADRESSE_IMCOMPLETE');
  if (ligne.email && !REGEX_EMAIL.test(ligne.email.toLowerCase())) error.errors.push('FORMAT_EMAIL_INCORRECT');
  if (ligne.siteWeb && !REGEX_WEBSITE.test(ligne.siteWeb.toLowerCase())) error.errors.push('FORMAT_SITE_WEB_INCORRECT');
  if (ligne.typesContactIds?.trim()) {
    ligne.typesContactIds = ligne.typesContactIds
      .trim().replace(/,$/, '')
      .trim().replace(/^,/, '')
      .trim();
    const regex = /^"([^"]+")(,"[^"]+")*$/;
    if (!regex.test(ligne.typesContactIds)) {
      error.errors.push('CONTACT_TYPE_MUST_BE_ENCLOSED_IN_QUOTES_AND_SEPARATED_BY_COMMAS');
    }
  }
  if (error.errors.length > 0) throw error;
}

export async function makeContactGenerated(file) {
  const lignes = file[0];
  const contacts = [];
  const errors = [];
  const civilites = [];
  const typesContacts = [];

  const tiers = (await getAllTiers({
    query: {
      societeId: store.getters['societe/societeActiveId'],
      type: TIERS_TYPE_CLIENT,
      sousType: [TIERS_SOUS_TYPE_AUCUN],
    },
    limit: NO_PAGINATION,
  })).data.result.items;

  // saut de la premiere vu qu'on a 2 lignes d'entete
  for (let i = 1; i < lignes.length; i += 1) {
    try {
      validationLigne(lignes[i], tiers);
      if (lignes[i]?.civilite) civilites.push(lignes[i].civilite);
      if (lignes[i]?.typesContactIds) {
        lignes[i].typesContactIds = extraireLibelles(lignes[i].typesContactIds);
        typesContacts.push(...lignes[i].typesContactIds);
      }
    } catch (e) {
      errors.push(e);
    }
  }
  if (errors.length > 0) {
    errors.unshift({ total: lignes.length - 1, totalErrors: errors.length });
    throw errors;
  }
  await Promise.all([
    completeParametrageGeneriqueNonExistant(PARAMETRES_KEYS.civilite, civilites),
    completeParametrageGeneriqueNonExistant(PARAMETRES_KEYS.typeContact,
      typesContacts, genererTypeContact()),
  ]);

  // saut de la premiere vu qu'on 2 lignes d'entete
  for (let i = 1; i < lignes.length; i += 1) {
    const contact = genererContact(lignes[i], tiers);
    contacts.push(contact);
  }

  return contacts;
}

export async function makeContactImport(contacts, modeTest) {
  await createAll(contacts, modeTest, true);
}
